import { DatabaseModel, ModelJson } from './database-model';

export const CUSTOM_LOCATION_KEY: string = '__CUSTOM_LOCATION__';

/**
 * Venue model used to store "venues" / predefined locations in the database
 */
export class Venue extends DatabaseModel {
    public key: string = '';
    public lat: number = 0;
    public long: number = 0;
    public title: string = '';
    public address: string = '';
    public projectKey: string = '';
    public createdOn: Date | any = null;

    constructor(json: any = null, key?: string) {
        super();

        if(json) this.fromJson(json);
        // Automatically assign keys to new objects
        if(!this.key) this.key = key || this.genKey();
    }

    /**
     * Convert database json to Venue instance (deserialize)
     */
    public fromJson(json): Venue {
        Object.assign(this, json);
        return this;
    }

    /**
     * Convert Venue instance to json (serialize)
     */
    public toJson(): ModelJson {
        let json = Object.assign({}, this);
        return json;
    }
}
